import { render, staticRenderFns } from "./MonitTableMenu.vue?vue&type=template&id=144fbaa0&"
import script from "./MonitTableMenu.vue?vue&type=script&lang=js&"
export * from "./MonitTableMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports